/**
 * useIsPro (Iter 73i+j) — zentrale Quelle für Pro/Lifetime-Plan-Check.
 *
 * Pro/Lifetime sind die einzigen Plans, die Premium-Features wie Mobile-Scan,
 * SB-Anbindung, Steuern etc. freischalten. „basic" zählt nicht als Pro.
 *
 * Iter 73j-Bugfix: Lifetime-User können auch `has_lifetime_access=true` mit
 * abweichendem `plan`-Feld haben (z.B. plan='free' nach manuellem Grant via
 * Admin). Wir checken beide Quellen.
 */
import { useAuth } from '@/contexts/AuthContext';

const PRO_PLANS = new Set(['pro', 'pro_monthly', 'pro_yearly', 'lifetime']);

export function useIsPro() {
  const { user } = useAuth();
  if (!user) return false;
  if (user.has_lifetime_access) return true;
  const plan = (user.plan || 'free').toLowerCase();
  return PRO_PLANS.has(plan);
}
